export const isValidObject = (obj: any) =>
  typeof obj === 'object' && obj !== null;

export const isObjWithKeys = (obj: any) =>
  isValidObject(obj) ? Object.keys(obj).length > 0 : false;
